module.exports = __webpack_public_path__ + "static/media/create-organization-dialog-background.98208c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/create-organization-dialog-background.png
// module id = 1841
// module chunks = 3